module.exports = __webpack_public_path__ + "img/jwgl-pk-zb.3abbdbe3.png";